import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

enum CreationGTMName {
    SURPRISE = "hidden_box_ad"
}

enum CreationGTMAction {
    VIEW = "view", // Ad was displayed on page
    SHOW = "show", // User interaction caused ad to show i.e: clicked on add that was hidden
    CLICK = "click" // User clicked on add and was redirected
}

const creativeGTMEvent = (reportData: {event: string; action?: string; box_name?: string; position?: number; ad_name?: string}) =>
    hitGoogleTagManager(reportData);

// Surprise ad actions
const surpriseEvent = (reportData: {action: string; box_name?: string; position?: number; ad_name?: string}) =>
    creativeGTMEvent({...reportData, event: CreationGTMName.SURPRISE});
const surpriseAdViewed = (reportData: {box_name: string; position: number; ad_name: string}) =>
    surpriseEvent({
        ...reportData,
        action: CreationGTMAction.VIEW
    });
const surpriseAdRevealed = (reportData: {box_name: string; position: number; ad_name: string}) =>
    surpriseEvent({
        ...reportData,
        action: CreationGTMAction.SHOW
    });
const surpriseAdRedirectionClick = (reportData: {box_name: string; position: number; ad_name: string}) =>
    surpriseEvent({...reportData, action: CreationGTMAction.CLICK});

// Reports actions to GTM related to recommendation modal events
export const reportCreation = {gtm: {surpriseAdViewed, surpriseAdRevealed, surpriseAdRedirectionClick}};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

enum CreationGTMName {
    SURPRISE = "hidden_box_ad"
}

enum CreationGTMAction {
    VIEW = "view", // Ad was displayed on page
    SHOW = "show", // User interaction caused ad to show i.e: clicked on add that was hidden
    CLICK = "click" // User clicked on add and was redirected
}

const creativeGTMEvent = (reportData: {event: string; action?: string; box_name?: string; position?: number; ad_name?: string}) =>
    hitGoogleTagManager(reportData);

// Surprise ad actions
const surpriseEvent = (reportData: {action: string; box_name?: string; position?: number; ad_name?: string}) =>
    creativeGTMEvent({...reportData, event: CreationGTMName.SURPRISE});
const surpriseAdViewed = (reportData: {box_name: string; position: number; ad_name: string}) =>
    surpriseEvent({
        ...reportData,
        action: CreationGTMAction.VIEW
    });
const surpriseAdRevealed = (reportData: {box_name: string; position: number; ad_name: string}) =>
    surpriseEvent({
        ...reportData,
        action: CreationGTMAction.SHOW
    });
const surpriseAdRedirectionClick = (reportData: {box_name: string; position: number; ad_name: string}) =>
    surpriseEvent({...reportData, action: CreationGTMAction.CLICK});

// Reports actions to GTM related to recommendation modal events
export const reportCreation = {gtm: {surpriseAdViewed, surpriseAdRevealed, surpriseAdRedirectionClick}};
